export default __webpack_public_path__ + "static/media/wordpress.c42e9e05.svg";